/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ClaudeAgentUsage,
  ClaudeAgentUsage$inboundSchema,
} from "./claudeagentusage.js";

/**
 * The agent usage payload discriminator.
 */
export const AgentUsageType = {
  Claude: "claude",
} as const;
/**
 * The agent usage payload discriminator.
 */
export type AgentUsageType = OpenEnum<typeof AgentUsageType>;

export type AgentUsage = {
  claude?: ClaudeAgentUsage | undefined;
  /**
   * The agent usage payload discriminator.
   */
  type: AgentUsageType;
};

/** @internal */
export const AgentUsageType$inboundSchema: z.ZodMiniType<
  AgentUsageType,
  unknown
> = openEnums.inboundSchema(AgentUsageType);

/** @internal */
export const AgentUsage$inboundSchema: z.ZodMiniType<AgentUsage, unknown> = z
  .object({
    claude: z.optional(ClaudeAgentUsage$inboundSchema),
    type: AgentUsageType$inboundSchema,
  });

export function agentUsageFromJSON(
  jsonString: string,
): SafeParseResult<AgentUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentUsage' from JSON`,
  );
}
